/* CircuitComps Bulk Buy: reveal animations + BOM upload to Shopify Files. */
(function () {
var root = document.querySelector('.ccb');
if (!root) return;
var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var io = new IntersectionObserver(function (es) {
es.forEach(function (e) {
if (!e.isIntersecting) return;
var el = e.target, d = +(el.dataset.d || 0);
setTimeout(function () { el.classList.add('in'); }, RM ? 0 : d);
io.unobserve(el);
});
}, { rootMargin: '0px 0px -6% 0px', threshold: .06 });
document.querySelectorAll('.ccb .rv').forEach(function (el) { io.observe(el); });
var rail = document.querySelector('.ccb .rail-in a[aria-current]');
if (rail && rail.parentElement) {
rail.parentElement.scrollTo({ left: rail.offsetLeft - 80, behavior: RM ? 'auto' : 'smooth' });
}
document.querySelectorAll('.ccb form[data-bom]').forEach(function (form) {
var api    = form.dataset.bom;
var input  = form.querySelector('input[type=file]');
var drop   = form.querySelector('.drop');
var picked = form.querySelector('.picked');
var pname  = picked && picked.querySelector('b');
var psize  = picked && picked.querySelector('em');
var clear  = picked && picked.querySelector('button');
var urlFld = form.querySelector('input[data-fileurl]');
var msg    = form.querySelector('.msg');
var submit = form.querySelector('[type=submit]');
var MAX    = 10 * 1024 * 1024;
var file   = null;
function say(text, kind) {
if (!msg) return;
msg.textContent = text;
msg.className = 'msg on ' + (kind || '');
if (!text) msg.className = 'msg';
}
function show(f) {
file = f;
if (!picked) return;
picked.classList.add('on');
if (pname) pname.textContent = f.name;
if (psize) psize.textContent = (f.size / 1024).toFixed(0) + ' KB';
if (drop) drop.style.display = 'none';
say('');
}
function reset() {
file = null;
if (input) input.value = '';
if (picked) picked.classList.remove('on');
if (drop) drop.style.display = '';
if (urlFld) urlFld.value = '';
}
function accept(f) {
if (!f) return;
if (f.size > MAX) { say('That file is larger than 10 MB. Please email it instead.', 'err'); return; }
if (!/\.(xlsx?|csv|ods|txt|pdf)$/i.test(f.name)) {
say('Please attach a spreadsheet - XLSX, XLS, CSV, ODS, TXT or PDF.', 'err'); return;
}
show(f);
}
if (drop) {
drop.addEventListener('click', function () { input && input.click(); });
drop.addEventListener('keydown', function (e) {
if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input && input.click(); }
});
['dragenter', 'dragover'].forEach(function (t) {
drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('over'); });
});
['dragleave', 'drop'].forEach(function (t) {
drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('over'); });
});
drop.addEventListener('drop', function (e) {
if (e.dataTransfer && e.dataTransfer.files.length) accept(e.dataTransfer.files[0]);
});
}
if (input) input.addEventListener('change', function () { accept(input.files[0]); });
if (clear) clear.addEventListener('click', function (e) { e.preventDefault(); reset(); });
form.addEventListener('submit', function (e) {
if (!file || (urlFld && urlFld.value)) return;
e.preventDefault();
if (!api) { say('Attachment is unavailable right now. Please email your BOM instead.', 'err'); return; }
submit.disabled = true;
var label = submit.textContent;
submit.textContent = 'Uploading your BOM...';
say('');
fetch(api + '/api/staged-upload', {
method: 'POST', headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ filename: file.name, mimeType: file.type || 'application/octet-stream', fileSize: String(file.size) })
})
.then(function (r) { if (!r.ok) throw new Error('staged'); return r.json(); })
.then(function (t) {
var fd = new FormData();
(t.parameters || []).forEach(function (p) { fd.append(p.name, p.value); });
fd.append('file', file);
return fetch(t.url, { method: 'POST', body: fd }).then(function (up) {
if (!up.ok) throw new Error('put');
return t.resourceUrl;
});
})
.then(function (resourceUrl) {
return fetch(api + '/api/bom-file', {
method: 'POST', headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ resourceUrl: resourceUrl, filename: file.name })
}).then(function (r) { if (!r.ok) throw new Error('file'); return r.json(); });
})
.then(function (res) {
if (urlFld) urlFld.value = res.url || res.fileUrl || '';
submit.textContent = 'Sending...';
form.submit();
})
.catch(function () {
submit.disabled = false;
submit.textContent = label;
say('We could not upload that file. Please email it to sales@circuitcomps.com and we will pick it up from there.', 'err');
});
});
});
})();